
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 9 9","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.955 1.228a.614.614 0 00-.868-.867L4.081 3.367 1.075.36a.614.614 0 10-.868.867l3.006 3.006L.207 7.241a.614.614 0 00.868.867l3.006-3.006 3.006 3.006a.614.614 0 10.868-.867L4.949 4.234l3.006-3.006z","fill":"#fff"}})])
          )
        }
      }
    